import QueueableRequest from './QueueableRequest';
import { bindParamsToRoute } from '../../helpers/url';
import { FUNNEL_IDS } from '../../config/api';

/**
 *
 * For each BEW Consent the frontend must provide a funnel_id to the backend, which
 * doucments the current version of the consent flow
 *
 * https://addmore.atlassian.net/wiki/spaces/DBNHAMOTELO/pages/751140912/BEW+-+Technisches+Konzept
 *
 */

export default class FunnelIdsRequest extends QueueableRequest {
  constructor() {
    super(bindParamsToRoute(FUNNEL_IDS, {}), {
      headers: {
        'X-Identifier': 'otelo-web',
      },
    });
  }
}
